module.exports = __webpack_public_path__ + "img/book2.6e6aab54.png";